export default __webpack_public_path__ + "static/media/1505.0f7e3074.png";